/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter } from "react-router-dom";
// import axios from "axios";

//import '../../css/event210621.css'

import "../../css/event220617.css";

// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import { isMobile } from "react-device-detect";

class Event202207_cart extends Component {
  _renderItem = () => {
    const { list } = this.props.childProps;

    const rst = list.map((item, index) => {
      return (
        <div className="thumb" key={index}>
          <span>
            <img src={item.img} />
          </span>
        </div>

        /*
                <div key={index}>
                    <div>
                        <img src = {item.img} />
                    </div>
                    <div>
                        {item.title}
                    </div>
                </div>
                */
      );
    });
    return rst;
  };
  _renderNull = () => {
    const { list } = this.props.childProps;
    let nullList = [];
    if (list.length === 4) {
      nullList = [1];
    } else if (list.length === 3) {
      nullList = [1, 2];
    } else if (list.length === 2) {
      nullList = [1, 2, 3];
    } else if (list.length === 1) {
      nullList = [1, 2, 3, 4];
    } else if (list.length === 0) {
      nullList = [1, 2, 3, 4, 5];
    }

    const lst = nullList.map((item, index) => {
      return (
        <div className="thumb" key={index}>
          <span>
            <img src="/img/event/event220617/bar_img.png" alt="준비중" />
          </span>
        </div>

        /*<div key={index}>null | </div>*/
      );
    });

    return lst;
  };
  render() {
    const { list } = this.props.childProps;
    return (
      <Fragment>
        <li className="list">
          {list.length > 0 ? this._renderItem() : null}
          {this._renderNull()}
        </li>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event202207_cart));
